import * as React from 'react';

import {
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
} from "@mui/material";
import { setPaymentSelectedPage } from './payment-reducer/actions';
import { useDispatch, useSelector } from 'react-redux';
import { PaymentPages } from './Utils';
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX } from '../../../constant';
import { Constant } from '../../../../webjam/constant';
import { getBaseConfig, getQueryString, isIpad, isSocialMobileApp } from '../../../Utils';
import { useDevice } from '../../Utils';
import { ct } from '../../../constant-Utils';


const tab = getQueryString("tab");
export default function SideBar(props) {
    const { isMobile, isTablet } = useDevice();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(true);
    const [openPage, setOpenPage] = React.useState(0);
    const { _menuList: menuList } = useMenuList();

    React.useEffect(() => {
        if (tab) {
            const tabIndex = menuList.find((t) => t?.key?.toLowerCase() === tab);
            setOpenPage(tabIndex?.id || 0);
            dispatch(setPaymentSelectedPage(PaymentPages[tabIndex.key]));
        }
    }, []);

    const {
        paymentSelectedPage
    } = useSelector(state => state[FEATURE_CUSTOM_PAYMENT]);

    const handleMenuClick = (data, index) => {
        if (data?.key === "RTA_SOCIAL_NETWORK") {
            return window.parent.location.href = Constant.App.socialUrl;
        }
        if (data.children.length) {
            if (openPage == index) {
                setOpenPage(null);
            } else {
                setOpenPage(index);
            }
        } else {
            dispatch(setPaymentSelectedPage(PaymentPages[data.key]));
        }
        console.log({ data, index })
        if ((isMobile || isTablet) && !data?.children?.length) {
            props.handleDrawerClose();
        }
    }

    return (
        <List
            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
            component="nav"
        >
            {
                menuList.filter(menu => menu?.isShow).map((data, index) => {
                    return (
                        <React.Fragment key={data.id}>
                            <ListItemButton
                                id={data.key}
                                onClick={() => handleMenuClick(data, index)}
                                className={(data.enTitle == paymentSelectedPage ? " page-active" : "") + " menu-list-blk"}
                            >
                                <ListItemIcon>
                                    {
                                        data.icon
                                    }
                                </ListItemIcon>
                                <ListItemText primary={data?.title} />
                                {
                                    data.children.length ? (openPage == index ?
                                        <i className="fa fa-chevron-up"></i>
                                        :
                                        <i className="fa fa-chevron-down"></i>
                                    ) : null
                                }
                            </ListItemButton>
                            {
                                data.children.length
                                    ?
                                    <>
                                        <Collapse in={openPage == index} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {
                                                    data.children.map((item, i) => {
                                                        return (
                                                            <ListItemButton sx={{ pl: 4 }}
                                                                id={item.key}
                                                                onClick={() => handleMenuClick(item, i)}
                                                                key={item.id}
                                                                td={item.title}
                                                                className={
                                                                    (item.enTitle == paymentSelectedPage)
                                                                        || (item.enTitle == PaymentPages.HOSTED_ROOM && paymentSelectedPage == PaymentPages.CREATE_ROOM)
                                                                        || (item.enTitle == PaymentPages.HOSTED_ROOM && paymentSelectedPage == PaymentPages.UPDATE_ROOM)
                                                                        ? " page-active" : ""}
                                                            >
                                                                {
                                                                    item.icon &&
                                                                    <ListItemIcon>
                                                                        {
                                                                            item.icon
                                                                        }
                                                                    </ListItemIcon>
                                                                }
                                                                <ListItemText primary={item?.title} />
                                                            </ListItemButton>
                                                        )
                                                    })
                                                }
                                            </List>
                                        </Collapse>
                                    </>
                                    : ""
                            }
                        </React.Fragment>
                    )
                })
            }
        </List>
    );
}


export const useMenuList = () => {
    const allowedMenuList = getBaseConfig("sideBarMenuList");
    const socialLinkImage = getBaseConfig("socialWebIcon");
    const _menuList = [
        //     {
        //     title: PaymentPages.INVITATION_LIST,
        //     key: "INVITATION_LIST",
        //     children: [],
        //     icon: <i className="fa fa-music fa-2x"></i>,
        //     id: 1
        // }, 
        {
            title: ct("rta-trmc.dashboard.sideBarMenu.ROOM_LIST"),
            enTitle: PaymentPages.ROOM_LIST,
            key: "ROOM_LIST",
            children: [{
                title: ct("rta-trmc.dashboard.sideBarMenu.HOSTED_ROOM"),
                enTitle: PaymentPages.HOSTED_ROOM,
                key: "HOSTED_ROOM",
                children: [],
                icon: <i className="fa fa-minus fa-2x"></i>,
                id: 1
            }, {
                title: ct("rta-trmc.dashboard.sideBarMenu.INVITED_ROOM"),
                enTitle: PaymentPages.INVITED_ROOM,
                key: "INVITED_ROOM",
                children: [],
                icon: <i className="fa fa-minus fa-2x"></i>,
                id: 2
            },

            // {
            //     title: PaymentPages.CREATE_ROOM,
            //     key: "CREATE_ROOM",
            //     children: [],
            //     icon: <i className="fa fa-music fa-2x"></i>,
            //     id: 3
            // }

            ],
            icon: <i className="fa fa-users fa-2x"></i>,
            id: 2,
            isShow: allowedMenuList.includes('roomList')
        },
        // {
        //     title: PaymentPages.CONTACT_LIST,
        //     key: "CONTACT_LIST",
        //     children: [{
        //         title: PaymentPages.MY_CONTACT,
        //         key: "MY_CONTACT",
        //         children: [],
        //         icon: <i className="fa fa-address-book fa-2x"></i>,
        //         id: 1
        //     }, {
        //         title: PaymentPages.CONTACT_GROUP,
        //         key: "CONTACT_GROUP",
        //         children: [],
        //         icon: <i className="fa fa-address-book fa-2x"></i>,
        //         id: 2
        //     }],
        //     icon: <i className="fa fa-address-book fa-2x"></i>,
        //     id: 3
        // },
        {
            title: ct("rta-trmc.dashboard.sideBarMenu.MY_RECORDINGS"),
            enTitle: PaymentPages.MY_RECORDINGS,
            key: "MY_RECORDINGS",
            children: [],
            icon: <i className="fa fa-video-camera fa-2x"></i>,
            id: 4,
            isShow: allowedMenuList.includes('myRecordings')
        },
        {
            title: ct("rta-trmc.dashboard.sideBarMenu.MY_DEVICE"),
            enTitle: PaymentPages.MY_DEVICE,
            key: "MY_DEVICE",
            children: [],
            icon: <i className="fa fa-television fa-2x"></i>,
            id: 5,
            isShow: allowedMenuList.includes('myDevice')
        },
        {
            title: ct("rta-trmc.dashboard.sideBarMenu.SUBSCRIPTION"),
            enTitle: PaymentPages.SUBSCRIPTION,
            key: "SUBSCRIPTION",
            children: [],
            icon: <i className="fa fa-usd fa-2x"></i>,
            id: 6,
            isShow: allowedMenuList.includes('subscription')
        },
        {
            title: ct("rta-trmc.dashboard.sideBarMenu.PAYMENT_HISTORY"),
            enTitle: PaymentPages.PAYMENT_HISTORY,
            key: "PAYMENT_HISTORY",
            children: [],
            icon: <i className="fa fa-history fa-2x"></i>,
            id: 7,
            isShow: allowedMenuList.includes('paymentHistory')
        },
        {
            title: ct("rta-trmc.dashboard.sideBarMenu.RTA_SOCIAL_NETWORK"),
            enTitle: PaymentPages.RTA_SOCIAL_NETWORK,
            key: "RTA_SOCIAL_NETWORK",
            children: [],
            icon: <img src={socialLinkImage} height="25px" />,
            id: 8,
            isShow: getBaseConfig("socialAllowed") && !isSocialMobileApp() && allowedMenuList.includes('rtaSocialNetwork')
    }
    ];

    return { _menuList };
}